import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { UserService } from 'src/app/modules/account/shared/user.service';
import { AuthService } from 'src/app/modules/auth/shared/auth.service';
import { MessageService } from 'src/app/modules/core/services/message.service';
import { LocalStoreService } from '../../services/local-store.service';
import { CryptoDepositComponent } from '../crypto-deposit/crypto-deposit.component';
import * as FileSaver from 'file-saver';
import domtoimage from 'dom-to-image-more';

@Component({
  selector: 'app-login-popup',
  templateUrl: './login-popup.component.html',
  styleUrls: ['./login-popup.component.scss'],
})
export class LoginPopupComponent implements OnInit {
  loginForm: FormGroup;
  loading = false;
  errors: any = [];
  hidePass = true;
  reload: boolean = true;
  private returnUrl: any;
  reChaptra = false;
  isRegist = false;
  user: any;

  constructor(
    private router: Router,
    private authService: AuthService,
    private fb: FormBuilder,
    public ref: DynamicDialogRef,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private userService: UserService,
    private translateService: TranslateService,
    private localStoreService: LocalStoreService,
    public config: DynamicDialogConfig,
    public dialogService: DialogService,
  ) {}

  /**
   * On init
   */
  ngOnInit(): void {
    // this.localStoreService.removeItem('user');
    // this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    if (
      this.config?.data?.reload != null ||
      this.config?.data?.reload != undefined
    ) {
      this.reload = this.config?.data?.reload;
      console.log('Alınan veriler:', this.reload);
    }
    this.initLoginForm();
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    this.loading = false;
  }

  initLoginForm(): void {
    this.loginForm = this.fb.group({
      username: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(32),
        ]),
      ],
      password: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(32),
        ]),
      ],
    });
  }

  async submit(): Promise<any> {
    if (this.loginForm.valid) {
      this.loading = true;
      const resData = {
        username: this.loginForm.value.username,
      };
      this.userService
        .getUserEmailByUsername(resData)
        .subscribe(async (res) => {
          if (res.success) {
            const result = await this.authService.loginWithMail({
              email: res.data,
              password: this.loginForm.value.password,
            });
            this.checkResult(result);
            this.loading = false;
            this.ref.close(true);
          } else {
            this.loading = false;
            this.messageService.showPopup(
              this.translateService.instant('ALERT.USERNAME_NOTFOUND'),
              'alert',
              'fail',
              'p0Popup'
            );
          }
        });
    } else {
      const controls = this.loginForm.controls;
      Object.keys(controls).forEach((controlName) =>
        controls[`${controlName}`].markAsTouched()
      );
      return;
    }
  }

  handleReChaptra() {
    this.reChaptra = true
  }

  resolved(captchaResponse: string) {
    console.log(`Resolved captcha with response: ${captchaResponse}`);
    this.isRegist = true;
    this.reChaptra = false;
    this.user = {
      username: "",
      password: ""
    }
    this.loginForm.patchValue(this.user)
  }

  checkResult(result: any): any {
    if (!result.success) {
      this.messageService.showPopup(
        this.translateService.instant(result.message),
        'alert',
        result.success ? 'success' : 'fail',
        'p0Popup'
      );
    } else if (result.success) {
      this.reload && window.location.reload();
    }
  }

  saveToFile() {
    const data = `Username: ${this.user.username}\nPassword: ${this.user.password}`;
    const blob = new Blob([data], { type: 'text/plain;charset=utf-8' });
    FileSaver.saveAs(blob, 'user_credentials.txt');
  }

  saveToImage() {
    const element = document.getElementById("formImage");
    if (element) {
      domtoimage
        .toJpeg(element, { quality: 0.95 })
        .then(function (dataUrl) {
          var link = document.createElement('a');
          link.download = 'user-profile.jpeg';
          link.href = dataUrl;
          link.click();
        });
    }
  }

  deposit() {
    // this.ref.close()
    this.dialogService.open(CryptoDepositComponent, {
      data: {
        status: "status",
      },
      showHeader: true,
      dismissableMask: true,
      width: '50vw',
      contentStyle: { "min-height": "50vh", padding: "0" },
      baseZIndex: 10000,
    });
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.loginForm.controls[`${controlName}`];
    if (!control) {
      return false;
    }

    const result =
      control.hasError(`${validationType}`) &&
      (control.dirty || control.touched);
    return result;
  }
}
